import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import fipayFonts from "../../theme/index";
import { useSelector } from "react-redux";

const Details = styled.div`
  margin-top: 60px;
`;

const DetailsRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 6px;
  margin-bottom: 6px;
`;

const DetailsTitle = styled.div`
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  text-align: left;
  color: #868686;
`;

const DetailSpan = styled.div<{ isActive?: boolean }>`
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  color: black;

  ${(props) =>
    props.isActive &&
    css`
      border: 1px solid orange;
      background-color: #04ff00;
    `}
`;
const DetailsButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  gap: 20px;
  margin-top: 50px;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 100%;
  }
`;

const DeactivateButton = styled.button`
  width: 192px;
  border: 1px solid #afafaf;
  border-radius: 10px;
  background-color: #afafaf;
  color: white;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 70%;
  }
`;

// const activeButon = styled.button``;

const InactiveButton = styled.button`
  width: 12%;
  border: 1px solid #e89d2b57;
  border-radius: 10px;
  background-color: #fef6eb;
  color: #e89d30;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  cursor: pointer;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 70%;
  }
`;

const EditButton = styled.button`
  border-radius: 10px;
  border: none;
  width: 192px;
  height: 44px;
  background-color: #00a603;
  color: white;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 108px;
  }
`;

const BoldHeader = styled.div`
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
`;

const DetailsComponent = () => {
  const selector = useSelector(
    (state: any) => state.createpaymentlink.paymentLinkArray
  );

  if (!selector || !selector[0] || !selector[0].options) {
    return <div>No product data available</div>;
  }

  const { options, advanceOption, products } = selector[0];

  const isOptionsAvailable = options !== undefined && options !== null;
  const isAdvanceOptionAvailable =
    advanceOption !== undefined && advanceOption !== null;

  const optionLabels = {
    collectCustomersShippingAddress: "Collect Customers Shipping Address",
    limitTheNumberOfPayments: "Limit payment",
    allowBusinessCustomersToProvideTaxIds: "Allow customer to provide tax IDs",
    collectTaxAutomatically: "Collect tax automatically",
    taxCategory: "Tax category",
    includeTaxInPrice: "Include tax in price",
    successMessage: "Customize success message",
    useYourCustomLink: "Customize payment link",
    redirectAfterPayment: "Redirect after payment",
  };

  const advanceOptionLabels = {
    redirectAfterPayment: "Redirect after payment",
    successMessage: "Customize success message",
    useYourCustomLink: "Customize payment link",
  };

  const optionDetails = isOptionsAvailable
    ? Object.entries(options)
        .filter(([key]) => key !== "__typename")
        .map(([key, value]) => ({
          title: (optionLabels as Record<string, string>)[key] || key,
          value: value === true ? "Yes" : "No",
        }))
    : [];

  const advanceOptionDetails = isAdvanceOptionAvailable
    ? Object.entries(advanceOption)
        .filter(([key]) => key !== "__typename")
        .map(([key, value]) => ({
          title: (advanceOptionLabels as Record<string, string>)[key] || key,
          value: value === true ? "Yes" : "No",
        }))
    : [];

  const createdAt =
    products.length > 0
      ? new Date(parseInt(products[0].createdAt)).toLocaleString()
      : "";

  const detailsData = [
    { title: "Date Created", value: createdAt },
    { title: "Status", value: "inactive" },
    { title: "Allow customer adjust quantity", value: "Yes" },
    { title: "Options", value: "", style: { fontWeight: "bold" } },
    ...optionDetails,
    { title: "Advance Options", value: "", style: { fontWeight: "bold" } },
    ...advanceOptionDetails,
  ];

  return (
    <Details>
      <div>
        <p>Details</p>
        {detailsData.map((detail, index) => (
          <DetailsRow key={index}>
            {detail.title === "Options" ||
            detail.title === "Advance Options" ? (
              <BoldHeader>{detail.title}</BoldHeader>
            ) : (
              <DetailsTitle>{detail.title}</DetailsTitle>
            )}
            {detail.title === "Status" ? (
              <InactiveButton>Inactive</InactiveButton>
            ) : (
              <DetailSpan isActive={detail.value.toLowerCase() === "active"}>
                {detail.value}
              </DetailSpan>
            )}
          </DetailsRow>
        ))}
      </div>
      <DetailsButton>
        <DeactivateButton>Deactivate Link</DeactivateButton>
        <EditButton>Edit Link</EditButton>
      </DetailsButton>
    </Details>
  );
};

export default DetailsComponent;
